import PublicScaffold from "@/routes/-components/PublicScaffold.js";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";

export const Root = (): ReactNode => {
    return (
        <PublicScaffold>
            <Outlet />
        </PublicScaffold>
    );
};

export const Route = createFileRoute("/review")({
    component: Root,
});
